export function shouldExcludeReportsLink(
  isBambi: boolean,
  isAdmin: boolean,
  isOwner: boolean
) {
  return !(isBambi || isAdmin || isOwner);
}
